/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './muteActor.defs.js'
export * as $defs from './muteActor.defs.js'
